module.exports = __webpack_public_path__ + "static/scale-model-of-pearl-mill-preserve-in-durham-north-carolina-a798ea863872e7ea7222a8eb14c9d113.png";